export const orderingDatesQuery = gql`
     query orderingDates($dispatchType: DispatchType!) {
         orderingDates(dispatchType: $dispatchType) {
             startDate
             endDate
             disallowedDates
         }
    }
`
